<template>
  <div class="lh-15 c-333">
    <!-- <section class="banner bgs-cover p-fix w-100p t-0">
      <div class="crumb d-f jc-fs ai-c ff-asl pl-60 in-pc">
        <a class="c-fff" href="/">Home</a><span class="c-fff"></span><a class="c-fff" href="/product">Product</a
        ><span class="c-fff"></span><a class="c-fff ff-as">Trion S1 3D LiDAR Scanner</a>
      </div>
      <div class="banner-content c-fff p-a">
        <div class="p-r ov-h">
          <h1 id="banner-title-1" class="banner-title m-0 lh-13 fw-400">
            <span class="d-b fw-700">FJD Trion<b>TM</b>S1</span><i class="d-b">3D LiDAR Scanner</i>
          </h1>
          <h1 id="banner-title-2" class="banner-title m-0 lh-13 p-a l-0 t-0">
            <span class="d-b fw-700"></span><i class="d-b">A New Way To Scan The World</i>
          </h1>
        </div>
        <nuxt-link to="/dealer" target="_blank" class="banner-btn d-ib ta-c">Contact Us</nuxt-link>
      </div>
      <div class="banner-pic p-a bgs-cover"></div>
    </section> -->
    <ProductBanner
      is-fixed
      is-scroll
      :banner-img="bannerImg"
      :product-name="$t('common.productName.S1')"
      :product-img-style="{ backgroundImage: `url(${bannerProductImg})` }"
      :main-title="'FJD TRION™S1'"
      :sub-title="'3D LIDAR SCANNER'"
      :slogan="'A New Way To Scan The World'"
    >
    </ProductBanner>

    <!-- banner:end -->
    <div class="content p-r z-3 bgc-fff">
      <div class="nav-anchor z-99 l-0 w-100p bgc-fff">
        <div class="h-100p m-a d-f jc-sb ai-c fs-16">
          <strong class="d-f ai-c fs-20 fw-500"
            >Trion S1 3D LiDAR Scanner<span class="in-h5 triangle-icon triangle-icon-fff bgs-cover bgp-c"></span
          ></strong>
          <div class="d-f">
            <div class="nav-anchor-item d-f jc-sb ai-c">
              <a href="#overview">Overview</a>
              <a href="#feature">Features</a>
              <a href="#download">Download</a>
              <nuxt-link to="/product/trion-s1-3d-lidar-scanner-specs">SPECs</nuxt-link>
            </div>
            <nuxt-link class="dealer-free-quote-btn d-ib ta-c bgc-222 c-fff in-pc" to="/basicinfo" target="_blank"
              >Free Quote</nuxt-link
            >
          </div>
        </div>
      </div>
      <!-- nav-anchor:end -->
      <section class="area-1 bgs-cover ov-h" id="overview">
        <div class="d-f jc-sb ai-fs">
          <ul class="d-f fw-w jc-sb ai-c fs-0 fg-0 fb-a">
            <li class="reveal">
              <i>
                <img
                  src="data:image/svg+xml,%3Csvg width='120' height='120' viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='translate(15 15)' fill='none' fill-rule='evenodd'%3E%3Cpath stroke='%23FFF' stroke-width='1.911' stroke-linejoin='round' d='M43 0l37.24 21.5v43L43 86 5.76 64.5v-43z'/%3E%3Ccircle fill='%23FFF' cx='14.041' cy='34.663' r='2.633'/%3E%3Ccircle fill='%23FFF' cx='14.041' cy='43.439' r='2.633'/%3E%3Ccircle fill='%23FFF' cx='14.041' cy='52.214' r='2.633'/%3E%3Ccircle fill='%23FFF' cx='14.041' cy='60.99' r='2.633'/%3E%3Ccircle fill='%23FFF' cx='23.694' cy='39.929' r='2.633'/%3E%3Ccircle fill='%23FFF' cx='23.694' cy='48.704' r='2.633'/%3E%3Ccircle fill='%23FFF' cx='23.694' cy='57.48' r='2.633'/%3E%3Ccircle fill='%23FFF' cx='23.694' cy='66.255' r='2.633'/%3E%3Ccircle fill='%23FFF' cx='33.347' cy='46.949' r='2.633'/%3E%3Ccircle fill='%23FFF' cx='33.347' cy='55.724' r='2.633'/%3E%3Ccircle fill='%23FFF' cx='33.347' cy='64.5' r='2.633'/%3E%3Ccircle fill='%23FFF' cx='33.347' cy='73.276' r='2.633'/%3E%3Ccircle fill='%23FFF' cx='43' cy='52.214' r='2.633'/%3E%3Ccircle fill='%23FFF' cx='43' cy='60.99' r='2.633'/%3E%3Ccircle fill='%23FFF' cx='43' cy='69.765' r='2.633'/%3E%3Ccircle fill='%23FFF' cx='43' cy='78.541' r='2.633'/%3E%3Ccircle fill='%23FFF' cx='43' cy='33.347' r='1.755'/%3E%3Ccircle fill='%23FFF' cx='52.653' cy='28.959' r='1.755'/%3E%3Ccircle fill='%23FFF' cx='33.347' cy='28.959' r='1.755'/%3E%3Ccircle fill='%23FFF' cx='61.429' cy='24.571' r='1.755'/%3E%3Ccircle fill='%23FFF' cx='23.694' cy='24.571' r='1.755'/%3E%3Ccircle fill='%23FFF' cx='70.204' cy='21.061' r='1.755'/%3E%3Ccircle fill='%23FFF' cx='14.918' cy='21.061' r='1.755'/%3E%3Ccircle fill='%23FFF' cx='43' cy='25.449' r='1.755'/%3E%3Ccircle fill='%23FFF' cx='52.653' cy='21.061' r='1.755'/%3E%3Ccircle fill='%23FFF' cx='33.347' cy='21.061' r='1.755'/%3E%3Ccircle fill='%23FFF' cx='61.429' cy='16.673' r='1.755'/%3E%3Ccircle fill='%23FFF' cx='23.694' cy='16.673' r='1.755'/%3E%3Ccircle fill='%23FFF' cx='43' cy='17.551' r='1.755'/%3E%3Ccircle fill='%23FFF' cx='52.653' cy='13.163' r='1.755'/%3E%3Ccircle fill='%23FFF' cx='33.347' cy='13.163' r='1.755'/%3E%3Ccircle fill='%23FFF' cx='43' cy='9.653' r='1.755'/%3E%3Cpath d='M5.76 21.5L43 43l37.24-21.5' stroke='%23FFF' stroke-width='.878' stroke-linecap='round' stroke-linejoin='round' stroke-dasharray='1.755102115207248,3.510204230414497'/%3E%3C/g%3E%3C/svg%3E"
                  alt="Points Per Second"
                  width="100%"
                  height="100%"
                />
              </i>
              <strong>320,000</strong>
              <span>Points Per Second</span>
            </li>
            <li class="reveal">
              <i>
                <img
                  src="data:image/svg+xml,%3Csvg width='120' height='120' viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='translate(16 17)' stroke='%23FFF' stroke-width='2' fill='none' fill-rule='evenodd'%3E%3Cellipse cx='44' cy='43.5' rx='9.522' ry='9.516'/%3E%3Cellipse cx='44' cy='43.5' rx='22.913' ry='22.901'/%3E%3Cellipse cx='44' cy='43.5' rx='38.217' ry='38.198'/%3E%3Cpath stroke-linecap='round' d='M44 87V75.527M44 11.473V0M0 43.022h11.478M76.522 43.022H88'/%3E%3C/g%3E%3C/svg%3E"
                  alt=" 0.8-2cm Accuracy"
                  width="100%"
                  height="100%"
                />
              </i>
              <strong>0.8-2cm</strong>
              <span>Accuracy</span>
            </li>
            <li class="reveal">
              <i>
                <img
                  src="data:image/svg+xml,%3Csvg width='120' height='120' viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='translate(21 7.006)' stroke='%23FFF' fill='none' fill-rule='evenodd'%3E%3Cellipse stroke-width='2' transform='rotate(-28 60.358 37.931)' cx='60.358' cy='37.931' rx='16.896' ry='3.68'/%3E%3Cellipse stroke-width='2' transform='rotate(-28 60.358 37.931)' cx='60.358' cy='37.931' rx='16.896' ry='3.68'/%3E%3Cpath d='M62.842 8.995l-3.09-5.824c-.945-1.8-8.37.329-16.587 4.753-8.216 4.425-14.111 9.47-13.167 11.27' stroke-width='2' stroke-linecap='round'/%3E%3Cpath d='M62.404 9.047c-2.46-.443-8.754 1.65-15.596 5.334-6.852 3.69-12.09 7.81-13.092 10.121' stroke-width='2' stroke-linecap='round'/%3E%3Cellipse stroke-linejoin='round' cx='16.849' cy='52.348' rx='2.732' ry='2.767'/%3E%3Cpath d='M23.224 20.986L38.252 49.12 15.028 64.8 0 37.13l23.224-16.143z' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' stroke-dasharray='3'/%3E%3Cpath stroke-width='2' d='M23.224 20.986h5.009'/%3E%3Cpath d='M52.824 45.43l-6.83 5.995V64.8c-2.424.615-4.701.922-6.831.922-2.13 0-4.256-.307-6.376-.922v-2.767H29.6L15.028 64.8' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' stroke-dasharray='3'/%3E%3Cpath stroke-width='2' stroke-linecap='round' stroke-linejoin='round' d='M32.332 23.292l-2.277 1.384-2.277-4.15 2.277-1.846 15.483 27.672-7.286 2.767'/%3E%3Cpath d='M75.138 29.749l-4.674-7.745a.923.923 0 0 0-.979-.426c-10.667 2.222-20.168 7.252-28.5 15.089' stroke-width='2' stroke-linecap='round'/%3E%3Cpath stroke-width='2' d='M61.932 9.457l6.83 12.452'/%3E%3Cpath d='M32.787 64.8l1.366 35.05c0 1.845-.303 3.229-.91 4.151-.911 1.384 7.741 3.69 14.572 0 0 0-6.83-22.137-4.554-38.279' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' stroke-dasharray='4,3'/%3E%3C/g%3E%3C/svg%3E"
                  alt="16 Sensors"
                  width="100%"
                  height="100%"
                />
              </i>
              <strong>16</strong>
              <span> Sensors</span>
            </li>
            <li class="reveal">
              <i>
                <img
                  src="data:image/svg+xml,%3Csvg width='120' height='120' viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='translate(10 10)' stroke='%23FFF' fill='none' fill-rule='evenodd'%3E%3Cellipse stroke-width='1.885' cx='50.331' cy='50.316' rx='7.54' ry='7.546'/%3E%3Cpath d='M54.562 27.116a23.686 23.686 0 0 0-4.231-.38c-13.014 0-23.563 10.557-23.563 23.58 0 13.023 10.55 23.58 23.563 23.58 13.013 0 23.563-10.557 23.563-23.58' stroke-width='1.885'/%3E%3Cpath d='M61.28 71.203a23.686 23.686 0 0 0 3.568-2.306c8.381-6.548 11.124-17.64 7.47-27.077m-8.36-10.737c-8.278-5.874-19.741-5.913-28.144.652-10.255 8.012-12.069 22.826-4.051 33.088' stroke-width='.5' stroke-dasharray='1'/%3E%3Cpath d='M58.669 12.548a38.759 38.759 0 0 0-8.338-.902c-21.343 0-38.644 17.313-38.644 38.67 0 21.357 17.301 38.67 38.644 38.67 21.342 0 38.643-17.313 38.643-38.67' stroke-width='1.885'/%3E%3Cpath d='M82.225 72.195a38.759 38.759 0 0 0 3.96-7.393c7.995-19.788-1.576-42.315-21.378-50.316-19.802-8-42.336 1.556-50.33 21.344-7.996 19.788 1.576 42.315 21.378 50.316' stroke-width='.5' stroke-linecap='round' stroke-linejoin='round' stroke-dasharray='1,1'/%3E%3Cpath stroke-width='1.5' d='M80.187 26.986l-21.5 18'/%3E%3Cpath stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' d='M58.548 38.57l.111 6.364 6.363-.111M79.968 33.194l.222-6.36-6.36-.222'/%3E%3C/g%3E%3C/svg%3E"
                  alt="120 Range"
                  width="100%"
                  height="100%"
                />
              </i>
              <strong>120 m</strong>
              <span>Range</span>
            </li>
            <li class="reveal">
              <i>
                <img
                  src="data:image/svg+xml,%3Csvg width='120' height='120' viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='translate(12 19)' stroke='%23FFF' fill='none' fill-rule='evenodd'%3E%3Cellipse stroke-width='2' cx='63.818' cy='9.293' rx='6.091' ry='6.107'/%3E%3Cellipse stroke-width='2' cx='78' cy='51.933' rx='6.091' ry='6.107'/%3E%3Cellipse stroke-width='2' cx='16.364' cy='5.467' rx='4.455' ry='4.467'/%3E%3Cellipse stroke-width='2' cx='5.455' cy='51.387' rx='4.455' ry='4.467'/%3E%3Cellipse stroke-width='2' cx='90.545' cy='27.333' rx='4.455' ry='4.467'/%3E%3Cellipse stroke-width='2' cx='63.273' cy='76.533' rx='4.455' ry='4.467'/%3E%3Cellipse stroke-width='2' cx='30' cy='70.52' rx='2.818' ry='2.827'/%3E%3Cellipse stroke-width='2' cx='61.636' cy='34.44' rx='2.818' ry='2.827'/%3E%3Cellipse stroke-width='2' cx='36.545' cy='37.72' rx='7.182' ry='7.2'/%3E%3Cpath stroke-width='1.5' stroke-dasharray='2,2' d='M6.545 47.013l8.728-37.72M20.727 6.013L57.818 8.2M19.091 9.293l14.182 22.414M9.818 49.2L30 40.453M33.273 69.973l39.272-14.76M32.727 71.067l26.182 5.466M66.545 73.8l9.819-15.853M61.636 31.707l2.182-16.4'/%3E%3Cpath stroke-width='2' stroke-dasharray='1,2' d='M74.727 47.013L63.818 36.627'/%3E%3Cpath stroke-width='1.5' stroke-dasharray='2,2' d='M82.364 47.013l6.545-16.4M31.091 67.787l4.364-22.96M58.909 35.533l-15.273 1.64M86.727 28.973L64.909 34.44M72.545 50.293l-30-9.84M8.182 55.213L27.818 68.88M69.273 11.48l18 13.12'/%3E%3C/g%3E%3C/svg%3E"
                  alt="Real-Time Point Cloud"
                  width="100%"
                  height="100%"
                />
              </i>
              <span>Real-Time <br />Point Cloud</span>
            </li>
            <li class="reveal">
              <i>
                <img
                  src="data:image/svg+xml,%3Csvg width='120' height='120' viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%23FFF' fill='none' fill-rule='evenodd'%3E%3Cg stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath stroke-width='1.9' d='M20 48.809V21h27.867M20 68.191V96h27.867M96 48.809V21H68.133'/%3E%3Cpath stroke-width='1.788' d='M96 68.191V96H68.133'/%3E%3C/g%3E%3Cpath stroke-width='1.9' stroke-linecap='round' d='M85.841 31.132L29.246 87.61'/%3E%3Cg stroke-dasharray='1.9,1.9' stroke-linejoin='round'%3E%3Cpath d='M73.885 53.048l-9.191 10.957h4.595l-7.558 8.945h4.626l-6.588 9.17h14.116' stroke-width='1.425'/%3E%3Cpath d='M73.885 53.048l8.746 10.957h-4.595l7.558 8.945h-4.626l6.588 9.17H73.44' stroke-width='1.425'/%3E%3Cpath stroke-width='1.9' d='M73.884 82.794v6.464'/%3E%3C/g%3E%3Cg stroke-dasharray='1.9,1.9' stroke-width='1.425'%3E%3Cpath d='M26.756 43.594l15.383-15.01 15.017 15.01' stroke-linejoin='round'/%3E%3Cpath d='M30.611 39.976v14.655M54.073 40.736v14.638'/%3E%3Cpath stroke-linejoin='round' d='M26.175 55.177h32.3'/%3E%3Cpath d='M48.992 35.223v-4.618c0-.319.259-.578.578-.578h2.888c.318 0 .577.26.577.578v8.66'/%3E%3Cpath d='M38.264 55.14V45.1h8.323v10.074' stroke-linejoin='round'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
                  alt="Indoor & Outdoor Scanning"
                  width="100%"
                  height="100%"
                />
              </i>
              <span>Indoor & Outdoor <br />Scanning</span>
            </li>
            <li class="reveal">
              <i>
                <img
                  src="data:image/svg+xml,%3Csvg width='120' height='120' viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='translate(23 12)' stroke='%23FFF' fill='none' fill-rule='evenodd'%3E%3Cpath stroke-width='1.82' stroke-linejoin='round' d='M3.652 32.176l25.191-16.365 16.36 25.2L20.01 57.378z'/%3E%3Cellipse stroke-width='1.365' cx='21.839' cy='44.553' rx='3.413' ry='3.415'/%3E%3Cpath d='M53.6.91l.389.002c2.972.05 5.464 1.019 6.646 3.066 1.182 2.048.774 4.691-.67 7.292-1.563 2.818-4.365 5.605-8.013 7.713-3.649 2.107-7.462 3.14-10.683 3.087-2.973-.05-5.465-1.019-6.647-3.067-1.181-2.048-.774-4.69.67-7.292C36.854 8.893 39.656 6.106 43.304 4 46.954 1.892 50.767.858 53.99.912zM34 14.508l-3.787 2.585M40.208 22.243l-4.534 3.045' stroke-width='1.82'/%3E%3Cpath stroke-width='1.82' stroke-linecap='round' d='M30.213 54.725l-7.452 1.106'/%3E%3Cpath stroke-width='1.365' stroke-linecap='round' stroke-linejoin='round' d='M50.646 36.285l.658 1.143-6.808 4.24'/%3E%3Cpath d='M60.854 3.858l3.99 7.166c.318 4.411-1.904 8.353-6.664 11.826-4.76 3.473-9.086 5.272-12.978 5.397l5.444 8.038c4.714-.755 9.077-2.833 13.09-6.234 4.012-3.4 5.64-7.08 4.886-11.04l-3.778-5.502' stroke-width='1.82' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M67.888 17.678c1.014-.215 1.917.314 2.71 1.587.792 1.274 1.904 3.281 3.336 6.023.482 4.687-1.672 8.848-6.46 12.482-4.788 3.634-9.925 5.157-15.41 4.57l-2.336-3.363' stroke-width='1.82'/%3E%3Cpath stroke-width='1.82' stroke-linejoin='round' d='M46.021 40.873l2.568 3.68 3.563-2.09'/%3E%3Cpath d='M0 80.791L23.974 62.78c2.794-3.076 4.725-5.18 5.794-6.315 1.686-1.788.697-4.59 4.41-6.001 1.254-.477 2.317-.108 2.734.95.489 1.24.57 2.816 1.191 2.34 1.413-1.081 3.052-1.841 4.15-2.34 2.996-1.361 5.823-1.392 6.75-.03.694 1.02.338 2.185-1.07 3.493 2.129.288 3.331 1.071 3.607 2.349.413 1.916 0 2.87-2.135 4.03 0 0 2.348.238 2.677 2.692.106.789.012 2.23-1.451 3.023 0 0 3.347 3.107-1.007 5.768-4.354 2.662-10.153 3.724-18.926 4.375-1.818.593-3.405 1.82-4.763 3.678L13.905 92.89' stroke-width='1.82' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath stroke-width='1.82' d='M48.69 44.098l-5.584 6.887'/%3E%3Cpath d='M36.466 76.783l.53 13.623c0 1.68-.276 2.94-.828 3.78-.83 1.26 7.046 3.36 13.263 0 0 0-2.728-8.845-3.967-19.088' stroke-width='1.82' stroke-linejoin='round'/%3E%3C/g%3E%3C/svg%3E"
                  alt="Lightweight  and More Portable"
                  width="100%"
                  height="100%"
                />
              </i>
              <span
                >Lightweight <br />
                and More Portable</span
              >
            </li>
            <li class="reveal">
              <i>
                <img
                  src="data:image/svg+xml,%3Csvg width='120' height='120' viewBox='0 0 120 120' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%23FFF' stroke-linejoin='round' stroke-width='2' fill='none' fill-rule='evenodd'%3E%3Cg transform='rotate(90 35.52 65.48)'%3E%3Crect width='59.586' height='37.846' rx='3.154'/%3E%3Cpath d='M59.586 9.462l5.603.782c.489.074.852.518.852 1.041v14.997c0 .523-.363.967-.852 1.04l-5.603 1.063'/%3E%3Cpath stroke-linecap='round' d='M18.229 16.046l11.877 8.836V12.964l11.251 9.364'/%3E%3C/g%3E%3Cg transform='rotate(90 16.423 40.423)'%3E%3Crect transform='matrix(-1 0 0 1 73.49 0)' x='6.952' width='59.586' height='37.846' rx='3.154'/%3E%3Cpath d='M6.455 9.462l-5.602.782c-.49.074-.853.518-.853 1.041v14.997c0 .523.363.967.853 1.04l5.602 1.063'/%3E%3Cpath stroke-linecap='round' d='M25.18 16.046l11.878 8.836V12.964l11.25 9.364'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E"
                  alt="Dual Battery"
                  width="100%"
                  height="100%"
                />
              </i>
              <span>Dual Battery <br />Hot-Swappable</span>
            </li>
          </ul>
          <div class="area-1-img fs-0 fg-0 fb-a in-pc">
            <img
              class="reveal"
              src="@/assets/images/trion-s1-3d-lidar-scanner/Overview-pic.jpg"
              alt="FJD Trion S1 3D LiDAR Scanner"
              width="100%"
              height="100%"
            />
            <!-- <video
                    width="100%"
                    height="100%"
                    x5-playsinline
                    x5-video-player-type="h5"
                    x-webkit-airplay="allow"
                    playsinline
                    webkit-playsinline
                    muted
                    preload="none"
                    loop
                    autoplay
                    src="//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/386204bc387702303059878638/2n8sVrII2icA.mp4"
                  ></video> -->
          </div>
        </div>
      </section>
      <!-- arean-1:end -->

      <section class="area-2 ov-h">
        <div class="w-12r m-a">
          <h2 class="ta-c ff-asb reveal">{{ $t('products.s1.area2H2') }}</h2>
          <div class="desc reveal c-666">
            FJD Trion S1 3D LiDAR scanner offers a new way to "look" the world around you. With 320,000 scan points per
            second, Trion S1 3D LiDAR scanner can quickly catch high-quality scans. Powered by Leading SLAM algorithm,
            Trion S1 can also capture, process and display accurate point clouds on the mobile terminal in real-time.
          </div>
          <div class="video-box p-r">
            <video
              width="100%"
              height="100%"
              x5-playsinline
              x5-video-player-type="h5"
              x-webkit-airplay="allow"
              playsinline
              webkit-playsinline
              muted
              preload="none"
              autoplay
              loop
              src="//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/bbabf20b387702303013954096/eEEhZ9ZxxtAA.mp4"
              :poster="mainVideoCoverImg"
            ></video>
            <!-- <div class="video-mask p-a t-0 l-0 w-100p h-100p"><i id="main-video" class="play-icon play-icon-fff c-p d-ib p-a c-c c-fff"></i></div> -->
          </div>
          <div class="img-box reveal">
            <img
              class="lazy-image"
              src="@/assets/images/trion-s1-3d-lidar-scanner/area-2-pic.jpg"
              width="100%"
              height="100%"
              alt="Trion S1 LiDAR 3D Scanner Components: Datalogger, Scanner, Mobile APP - Trion Scan, Web Software - Trion Metahub"
            />
          </div>
        </div>
      </section>
      <!-- area-2:end -->

      <section class="area-3 bgr-nr">
        <div class="w-12r m-a">
          <h2 class="ta-c ff-asb reveal">Application Scenarios</h2>
          <div class="desc ta-c reveal c-666">Indoor, outdoor, and underground without a GNSS receiver.</div>
          <ul class="d-f jc-sb fw-w ai-fs">
            <li class="p-r reveal">
              <img
                width="100%"
                height="100%"
                class="lazy-image"
                src="@/assets/images/trion-s1-3d-lidar-scanner/Application-Scenarios-1.jpg"
                data-m-original="@/assets/images/trion-s1-3d-lidar-scanner/Application-Scenarios-1-m.jpg"
                alt="Scan to BIM, Application of LiDAR 3D Scanner"
              />
              <strong class="d-b p-a">Scan to BIM</strong>
            </li>
            <li class="p-r reveal">
              <img
                width="100%"
                height="100%"
                class="lazy-image"
                src="@/assets/images/trion-s1-3d-lidar-scanner/Application-Scenarios-2.jpg"
                alt="Trion S1 3D LiDAR Scanner applied in Facility Digitalization"
              />
              <strong class="d-b p-a">Heritage Conservation</strong>
            </li>
            <li class="p-r reveal">
              <img
                width="100%"
                height="100%"
                class="lazy-image"
                src="@/assets/images/trion-s1-3d-lidar-scanner/Application-Scenarios-3.jpg"
                alt="Heritage Conservation -  Application of LiDAR 3D Scanner"
              />
              <strong class="d-b p-a">Facility Digitalization</strong>
            </li>
            <li class="p-r reveal">
              <img
                width="100%"
                height="100%"
                class="lazy-image"
                src="@/assets/images/trion-s1-3d-lidar-scanner/Application-Scenarios-4.jpg"
                alt="Pile Measurement -  Application of TTrion S1 Handheld LiDAR Scanner"
              />
              <strong class="d-b p-a">Pile Measurement</strong>
            </li>
            <li class="p-r reveal">
              <img
                width="100%"
                height="100%"
                class="lazy-image"
                src="@/assets/images/trion-s1-3d-lidar-scanner/Application-Scenarios-5.jpg"
                alt="Volume Measurement
                  -  Application of Trion S1 Handheld LiDAR Scanner"
              />
              <strong class="d-b p-a">Mining Tunnel</strong>
            </li>
            <li class="p-r reveal">
              <img
                width="100%"
                height="100%"
                class="lazy-image"
                src="@/assets/images/trion-s1-3d-lidar-scanner/Application-Scenarios-6.jpg"
                alt="Trion S1 3D LiDAR Scanner applied in Forestry Surveying"
              />
              <strong class="d-b p-a">Forestry Surveying</strong>
            </li>
          </ul>
        </div>
      </section>
      <!-- area-3 -->

      <section class="area-4 bgp-c bgs-cover lazy-image area-4-img" id="feature">
        <div class="w-12r m-a c-fff">
          <div class="area-4-mod1">
            <h2 class="ta-r ff-asb reveal">Real-time Point Cloud</h2>
            <div class="desc ta-r f-r reveal">Real-time display of point cloud and process by SLAM.</div>
            <div class="text-video-box d-f jc-sb c-b">
              <ul class="ta-r d-f fd-c jc-sb">
                <li><strong>320,000</strong><span>Points Per Second</span></li>
                <li><strong>0.8-2cm</strong><span>Accuracy</span></li>
              </ul>
              <div class="video-box p-r">
                <video
                  ref="area4Video1"
                  width="100%"
                  height="100%"
                  x5-playsinline
                  x5-video-player-type="h5"
                  x-webkit-airplay="allow"
                  playsinline
                  webkit-playsinline
                  muted
                  preload="none"
                  loop
                  class="area4-video1"
                  data-src="//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/1fbbd315387702303052959368/w4HioTaSDyoA.mp4"
                  :poster="RealTimeImg"
                ></video>
              </div>
            </div>
          </div>

          <div class="area-4-mod2">
            <h2 class="ff-asb reveal">Further Range</h2>
            <div class="desc reveal">
              Thanks to built-in LiDAR 3D scanning technology, Trion S1 3D LiDAR scanner allows you to capture precise
              long-range 3D measurements of complex objects and shapes from up to 120 meters.
            </div>
            <div class="text-video-box d-f jc-sb fd-r">
              <ul class="d-f fd-c jc-sb">
                <li><strong>360°</strong><span>Vertical FOV</span></li>
                <li><strong>270°</strong><span>Horizontal FOV</span></li>
                <li><strong>120m</strong><span>Range</span></li>
              </ul>
              <div class="video-box p-r">
                <video
                  ref="area4Video2"
                  width="100%"
                  height="100%"
                  x5-playsinline
                  x5-video-player-type="h5"
                  x-webkit-airplay="allow"
                  playsinline
                  webkit-playsinline
                  muted
                  class="area4-video2"
                  preload="none"
                  loop
                  data-src="//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/1b34aed5387702303052777829/CGdXa0mYOooA.mp4"
                  :poster="FutureRangeVideoCoverImg"
                ></video>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- area-4:end -->

      <section class="area-5 bgr-nr">
        <div class="w-12r m-a">
          <h2 class="ta-c ff-asb reveal">Dual Battery</h2>
          <div class="desc ta-c reveal c-666">
            Hot-swappable dual batteries for uninterruptible power supply. Reliable SLAM for scanning across multiple
            floors.
          </div>
          <div class="video-box p-r">
            <video
              width="100%"
              height="100%"
              x5-playsinline
              x5-video-player-type="h5"
              x-webkit-airplay="allow"
              playsinline
              webkit-playsinline
              muted
              preload="none"
              loop
              data-src="//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/ca8221c0387702303241712540/JgYyodP9YwcA.mp4"
              class="area5-video"
              poster="https://1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/e43284f9387702303058549398/sampleSnapshot/sampleSnapshot_10_0.jpg"
            ></video>
          </div>
        </div>
      </section>
      <!-- area-5:end -->
      <!--
      <section class="area-6">
        <div class="w-12r m-a">
          <h2 class="ta-c ff-asb">Portability</h2>
          <div class="ta-c desc">
            As a 3D LiDAR scanner, it is lightweight and portable, which could be used indoor;outdoor and underground,
            even in the sky with drones.
          </div>
          <div class="area-6-swiper-in-h5 ov-h p-r">
            <ul class="d-f jc-sb ta-c swiper-wrapper">
              <li class="swiper-slide">
                <i>
                  <img
                    src="@/assets/images/trion-s1-3d-lidar-scanner/Protability-1.jpg"
                    data-original="@/assets/images/trion-s1-3d-lidar-scanner/Protability-1.jpg"
                    data-m-original="@/assets/images/trion-s1-3d-lidar-scanner/Protability-1-m.jpg"
                    width="100%"
                    height="100%"
                    alt="Handheld LiDAR scanner"
                  />
                </i>
                <span>Handheld</span>
              </li>
              <li class="swiper-slide">
                <i>
                  <img
                    src="@/assets/images/trion-s1-3d-lidar-scanner/Protability-2.jpg"
                    width="100%"
                    height="100%"
                    alt="Backpack LiDAR 3D scanner"
                  />
                </i>
                <span>Backpack</span>
              </li>
              <li class="swiper-slide">
                <i>
                  <img
                    src="@/assets/images/trion-s1-3d-lidar-scanner/Protability-3.jpg"
                    data-original=""
                    data-m-original="@/assets/images/trion-s1-3d-lidar-scanner/Protability-3-m.jpg"
                    width="100%"
                    height="100%"
                    alt="Drone LiDAR scanner"
                  />
                </i>
                <span>Drone</span>
              </li>
              <li class="swiper-slide">
                <i>
                  <img
                    src="@/assets/images/trion-s1-3d-lidar-scanner/Protability-4.jpg"
                    data-original=""
                    data-m-original="@/assets/images/trion-s1-3d-lidar-scanner/Protability-4-m.jpg"
                    width="100%"
                    height="100%"
                    alt="Car & Ship LiDAR 3D scanner"
                  />
                </i>
                <span>Car & Ship</span>
              </li>
            </ul>
            <div class="area-6-pagination"></div>
          </div>
        </div>
      </section> -->

      <Application
        class="area-6"
        :app-desc="$t('products.s1.area7Desc')"
        :app-h2="$t('products.s1.area7H2')"
        :application-data="applicationData"
      />

      <!-- area-6:end -->
      <section class="area-7" id="download">
        <div class="w-12r m-a">
          <h2 class="ta-c ff-asb area-7-title reveal">Your Own Point Clouds Studio</h2>
          <div class="d-f ai-fs">
            <div class="area-7-swiper p-r ov-h">
              <!-- <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div class="img-box">
                    <img
                      class="lazy-image"
                      data-original="@/assets/images/trion-s1-3d-lidar-scanner/TRION-METAHUB.png"
                      alt="Trion Scan - Trion S1 3D LiDAR Scanner Mobile APP"
                      width="100%"
                      height="100%"
                    />
                  </div>
                </div>

                <div class="swiper-slide">
                  <div class="img-box">
                    <img
                      class="lazy-image"
                      data-original="@/assets/images/trion-s1-3d-lidar-scanner/Trion-Scan.png"
                      alt="Trion Metahub - Trion S1 3D LiDAR Web Software"
                      width="100%"
                      height="100%"
                    />
                  </div>
                </div>
              </div> -->
              <client-only>
                <swiper class="" :options="swiperOption" ref="bannerSwiper">
                  <!-- slides -->
                  <swiper-slide v-for="(item, index) in bannerData" :key="index">
                    <div class="img-box">
                      <img
                        class="lazy-image"
                        :src="item.img"
                        data-original="@/assets/images/trion-s1-3d-lidar-scanner/TRION-METAHUB.png"
                        :alt="item.alt"
                        width="100%"
                        height="100%"
                      />
                    </div>
                  </swiper-slide>
                  <!-- <div class="banner-pagination p-a ta-c" slot="pagination"></div> -->
                </swiper>
              </client-only>
            </div>

            <div class="area-7-pagination-wrap p-r">
              <ul class="area-7-pagination"></ul>
              <i ref="line" class="line" :class="isTranslateY ? 'line-y' : 'line-d'"></i>
            </div>
          </div>
          <!-- <p class="coming-soon" style="">* Coming soon</p> -->
        </div>
      </section>
      <!-- area-7:end -->
    </div>
  </div>
</template>

<script>
  import { gsap } from 'gsap'
  import { ScrollTrigger } from 'gsap/dist/ScrollTrigger.js'
  import bannerScroll from '@/mixins/bannerScroll.js'
  import ProductBanner from '@/components/ProductBanner'
  import Application from '@/components/Application'

  import bannerImg from '@/assets/images/trion-s1-3d-lidar-scanner/banner.jpg'
  import bannerProductImg from '@/assets/images/trion-s1-3d-lidar-scanner/banner-pic.png'

  // import

  import RealTimeImg from '@/assets/images/trion-s1-3d-lidar-scanner/Real-Time-Point-Cloud-video-cover.jpg'
  import mainVideoCoverImg from '@/assets/images/trion-s1-3d-lidar-scanner/main-video-cover.jpg'
  import TRIONMETAHUBImg from '@/assets/images/trion-s1-3d-lidar-scanner/TRION-METAHUB.png'
  import TrionScanImg from '@/assets/images/trion-s1-3d-lidar-scanner/Trion-Scan.png'
  import FutureRangeVideoCoverImg from '@/assets/images/trion-s1-3d-lidar-scanner/Future-Range-video-cover.jpg'
  // import AppLink from '@/components/AppLink'

  const area7TabItemText = ['Trion Scan', 'Trion Metahub']
  const area7TabItemDesc = ['Real-time visualization of 3D point clouds software', 'Point cloud post-process software']
  const area7TabItemTextMore = [
    '<p>· Displays the scanned project files, storage<br/>&nbsp;&nbsp;capacity, and battery life.</p><p>· Visualizes the point cloud in real-time.</p><p>· Tracks the path in real-time.</p><p>· Manages and downloads the project files.</p>',
    '<p>· Denoises and colorizes point clouds.</p><p>· Stitches point clouds, maps shadow, transforms <br/>&nbsp;&nbsp;coordinates, and does automatic plane fitting. </p><p>· Classifies point clouds, produces 2D drawings, <br/>&nbsp;&nbsp;and builds 3D models. '
  ]
  const donwloadLink = [
    'https://fj-fjdynamics-storage-01-1304943718.cos.ap-shanghai.myqcloud.com/fjslam_update_2.7.26.0-scan-product-en.tar.gz',
    'https://fj-fjdynamics-storage-01-1304943718.cos.ap-shanghai.myqcloud.com/TrionMetahubV1.000.D.0102.setup.zip'
  ]

  export default {
    components: {
      // AppLink
      ProductBanner,
      Application
    },
    mixins: [bannerScroll],
    data() {
      const vm = this
      return {
        bannerImg,
        bannerProductImg,
        RealTimeImg,
        mainVideoCoverImg,
        FutureRangeVideoCoverImg,
        isTranslateY: false,
        bannerData: [
          {
            img: TRIONMETAHUBImg,
            alt: 'Trion Scan - Trion S1 3D LiDAR Scanner Mobile APP'
          },
          {
            img: TrionScanImg,
            alt: 'Trion Metahub - Trion S1 3D LiDAR Web Software'
          }
        ],
        applicationData: [
          {
            imgUrl: require('@/assets/images/trion-s1-3d-lidar-scanner/Protability-1.jpg'),
            imgDesc: 'products.s1.area7img1'
          },
          {
            imgUrl: require('@/assets/images/trion-s1-3d-lidar-scanner/Protability-2.jpg'),
            imgDesc: 'products.s1.area7img2'
          },
          {
            imgUrl: require('@/assets/images/trion-s1-3d-lidar-scanner/Protability-3.jpg'),
            imgDesc: 'products.s1.area7img3'
          },
          {
            imgUrl: require('@/assets/images/trion-s1-3d-lidar-scanner/Protability-4.jpg'),
            imgDesc: 'products.s1.area7img4'
          }
        ],
        swiperOption: {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          effect: 'fade',
          autoplay: {
            delay: 5000
          },
          pagination: {
            el: '.area-7-pagination',
            clickable: true,
            renderBullet(index, className) {
              return (
                '<li class="' +
                className +
                '">' +
                '<strong class="d-f ai-c">' +
                area7TabItemText[index] +
                '<a onclick="window.open(\'' +
                donwloadLink[index] +
                '\')" class="downloadIcon bgs-cover"></a></strong>' +
                '<div>' +
                area7TabItemDesc[index] +
                '</div>' +
                '<div class="more-text">' +
                area7TabItemTextMore[index] +
                '</div>' +
                '</li>'
              )
            }
          },
          on: {
            slideChange() {
              const index = this.realIndex
              vm.editSwiperLineStyle(index)
              // vm.$nextTick(() => {
              //   const lineRefEl = vm.$refs.line && vm.$refs.line.$el
              //   console.log('[ lineRefEl ] >', lineRefEl, index)
              //   // lineRefEl.style.transform = `translateY(145*${index}/100rem)`
              // })
              // const line = document.getElementsByClassName('line')
              // console.log('[ index ] >', index, line)
              // line.style.transform = `translateY(145*${index}/100rem)`
              // line.css('transform', 'translateY(' + (145 * index) / 100 + 'rem)')
            }
          }
        }
      }
    },
    head() {
      return {
        script: [
          {
            type: 'application/ld+json',
            json: {
              '@context': 'https://schema.org/',
              '@type': 'ItemPage',
              '@graph': [
                {
                  '@type': 'Product',
                  name: 'Trion S1 LiDAR 3D Scanner',
                  url: 'https://www.fjdynamics.com/product/trion-s1-3d-lidar-scanner',
                  image: 'https://www.fjdynamics.com/images/trion-s1-3d-lidar-scanner/Overview-pic.jpg',
                  description:
                    'FJD Trion S1 LiDAR 3D scanner SLAM-based, high portability: handheld, backpack, drone, car, ship.',
                  brand: {
                    '@type': 'Brand',
                    name: 'FJDynamics'
                  },
                  review: [
                    {
                      '@type': 'Review',
                      reviewBody: 'Easy use with high accuracy.',
                      reviewRating: {
                        '@type': 'Rating',
                        ratingValue: '5',
                        bestRating: '5'
                      },
                      author: {
                        '@type': 'Person',
                        name: 'Huguette'
                      }
                    }
                  ]
                },
                {
                  '@type': 'BreadcrumbList',
                  itemListElement: [
                    {
                      '@type': 'ListItem',
                      position: 1,
                      name: 'Home',
                      item: 'https://www.fjdynamics.com'
                    },
                    {
                      '@type': 'ListItem',
                      position: 2,
                      name: 'Product',
                      item: 'https://www.fjdynamics.com/product'
                    },
                    {
                      '@type': 'ListItem',
                      position: 3,
                      name: 'Trion S1 LiDAR 3D Scanner'
                    }
                  ]
                }
              ]
            }
          }
        ],
        title: 'Trion S1 Handheld LiDAR 3D Scanner, 0.8-2cm High Accuracy',
        meta: [
          {
            hid: 'keywords',
            name: 'keywords',
            content: 'Handheld LiDAR scanner, 3D LiDAR scanner, LiDAR 3D scanner'
          },
          // hid is used as unique identifier. Do not use `vmid` for it as it will not work
          {
            hid: 'description',
            name: 'description',
            content:
              'FJD Trion S1 LiDAR 3D scanner, high portability: handheld, backpack, drone, car, ship. 320,000 scan points per second, quickly catch high-quality scans.'
          }
        ]
      }
    },
    mounted() {
      // eslint-disable-next-line nuxt/no-env-in-hooks
      if (process.browser) {
        gsap.registerPlugin(ScrollTrigger)
        this.bannerAnimate()
        this.area6ProtabilityAnimate()
        ;['area4-video1', 'area4-video2', 'area5-video'].forEach((item) => this.loadVideoPlay(item))
        // this.loadVideoPlay('area4-video1')
      }
    },
    created() {},
    methods: {
      bannerAnimate() {
        // eslint-disable-next-line no-undef
        gsap
          .timeline({
            scrollTrigger: {
              trigger: '.banner-content',
              start: 0,
              end: '+=100',
              duration: 1.5,
              scrub: 1
            }
          })
          .to('#banner-title-1', {
            opacity: 0,
            y: '-100%',
            duration: 1
          })
          .to('#banner-title-2', {
            opacity: 1,
            y: '0',
            duration: 1.5
          })
      },
      area6ProtabilityAnimate() {
        gsap.from('.area-6 li', {
          scrollTrigger: {
            trigger: '.area-6',
            // pin: true,
            start: '60% bottom',
            end: '60% bottom'
            // scrub: 1,
            // markers: true
            // onEnter:function(self){
            //   var imgs=$(self.trigger).find("img")
            //   imgs.each(function(i,n){
            //     $(n).attr("src",$(n).attr("data-original"))
            //   })
            // }
          },
          stagger: 0.3,
          duration: 1,
          y: '100%',
          opacity: 0
        })
      },
      editSwiperLineStyle(idx) {
        this.isTranslateY = idx === 1
      },
      loadVideoPlay(el) {
        ScrollTrigger.create({
          trigger: `.${el}`,
          onEnter(self) {
            if (!self.trigger.src) {
              self.trigger.src = self.trigger.dataset.src
              document.getElementsByClassName(`${el}`)[0].play()
            }
          }
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  @media screen and (min-width: 768px) {
    .fs-40 {
      font-size: 0.4rem;
    }
    .fs-20 {
      font-size: 0.2rem;
    }
    .fs-18 {
      font-size: 0.18rem;
    }
    .fs-16 {
      font-size: 0.16rem;
    }

    .pl-360 {
      padding-left: 3.6rem;
    }
    .pr-360 {
      padding-right: 3.6rem;
    }
    .content h2 {
      font-size: 0.48rem;
    }
    .main {
      margin-top: 3.958vw;
    }

    /* banner */
    .banner {
      height: 8rem;
      // top: 0.75rem;
      background-image: url('@/assets/images/trion-s1-3d-lidar-scanner/banner.jpg');
    }
    .banner .crumb {
      padding-top: 0.34rem;
      font-size: 0.16rem;
      display: flex;
      align-items: center;
      line-height: 1;
    }
    .banner .crumb span {
      height: 0.13rem;
    }
    .banner .crumb a:hover {
      color: #fff;
    }
    .banner-content {
      left: 3.46rem;
      top: 2.7rem;
      width: 80%;
    }
    .banner-title {
      margin-bottom: 0.08rem;
    }
    .banner-title span {
      font-size: 0.64rem;
    }
    .banner-title i {
      font-size: 0.45rem;
    }
    .banner-title b {
      display: inline-block;
      margin: 0 0.04rem;
      top: -0.4rem;
      font-weight: 400;
      font-size: 0.18rem;
      position: relative;
    }
    .banner-btn {
      margin-top: 0.32rem;
      font-size: 0.24rem;
      width: 1.7rem;
      line-height: 0.48rem;
      background: rgba(255, 255, 255, 0.65);
      transition: background-color 0.3s linear;
    }
    .banner-btn:hover {
      background: rgba(255, 255, 255, 0.75);
    }
    .banner-pic {
      width: 4rem;
      height: 4rem;
      bottom: 0;
      right: 1.6rem;
      background-image: url('@/assets/images/trion-s1-3d-lidar-scanner/banner-pic.png');
    }
    #banner-title-2 {
      padding-top: 0.5rem;
      transform: translateY(100%);
      opacity: 0;
    }

    .content {
      margin-top: calc(8rem + 0.75rem);
    }

    /* nav-anchor */
    .nav-anchor {
      height: 0.56rem;
      top: 0.75rem;
      position: sticky;
      box-shadow: 0px 0.02rem 0.04rem 0px rgba(0, 0, 0, 0.1);
    }
    .nav-anchor > div {
      padding-left: 1.6rem;
      padding-right: 1.6rem;
    }
    .nav-anchor a {
      margin-left: 0.8rem;
    }
    .nav-anchor .nav-anchor-item a:hover {
      font-weight: 700;
    }
    .nav-anchor .dealer-free-quote-btn {
      width: 1.2rem;
      line-height: 0.32rem;
      transition: background-color 0.3s linear;
    }
    .nav-anchor .dealer-free-quote-btn:hover {
      color: #fff;
      background-color: rgba(34, 34, 34, 0.85);
    }

    /* area-1-img */
    .area-1 {
      height: 7.2rem;
      background-image: url('@/assets/images/trion-s1-3d-lidar-scanner/Overview-bg.jpg');
    }
    .area-1 ul {
      width: 9.6rem;
      margin: 1.29rem 0 0 1.7rem;
    }
    .area-1 li {
      width: 2.4rem;
      text-align: center;
      margin-bottom: 0.66rem;
    }
    .area-1 li i {
      display: block;
      margin: 0 auto 0.18rem;
      width: 1.2rem;
      height: 1.2rem;
    }
    .area-1 li strong,
    .area-1 li span {
      display: block;
      color: #fff;
      font-size: 0.2rem;
    }
    .area-1 li strong {
      font-weight: 400;
    }
    .area-1-img {
      width: 6.8rem;
      height: 6.8rem;
      margin-top: 0.4rem;
      margin-right: 0.67rem;
    }

    /* area-2 */
    .area-2 {
      padding-top: 1.4rem;
    }
    .area-2 .desc {
      padding: 0.32rem 0;
    }
    .area-2 .video-box {
      width: 100%;
      margin-bottom: 2rem;
    }
    .area-2 .video-box video {
      object-fit: cover;
    }
    .area-2 .img-box {
      height: 6.75rem;
      margin-bottom: 0.24rem;
    }
    .area-2 .text span {
      margin: 0 0.8rem;
      padding: 0.02rem 0.09rem;
    }

    /* area-3 */
    .area-3 {
      padding-top: 1.5rem;
      padding-bottom: 1.4rem;
    }
    .area-3 .desc {
      padding: 0.16rem 0 0.48rem;
    }
    .area-3 li {
      width: 3.92rem;
    }
    .area-3 li strong {
      bottom: 0.2rem;
      left: 0.24rem;
      color: #fff;
      font-weight: 500;
    }
    .area-3 li:nth-child(1) {
      height: 2.4rem;
    }
    .area-3 li:nth-child(2) {
      height: 4.74rem;
    }
    .area-3 li:nth-child(3) {
      height: 2.4rem;
    }
    .area-3 li:nth-child(4) {
      height: 4.74rem;
      margin-top: -2.22rem;
    }
    .area-3 li:nth-child(5) {
      height: 2.4rem;
      margin-top: 0.12rem;
    }
    .area-3 li:nth-child(6) {
      height: 4.74rem;
      margin-top: -2.22rem;
    }

    /* area-4 */
    .area-4 {
      height: 20.38rem;
    }
    .area-4-img {
      background-image: url('@/assets/images/trion-s1-3d-lidar-scanner/Real-time-Point-Cloud-bg.jpg');
    }

    .area-4 h2 {
      padding-top: 2rem;
    }
    .area-4 .desc {
      margin: 0.16rem 0 0.32rem;
      width: 9.96rem;
    }
    .area-4 .video-box {
      width: 9.96rem;
      height: 5.6rem;
    }
    .area-4 .video-box video {
      object-fit: cover;
    }
    .area-4-mod1 ul {
      margin-right: 0.18rem;
      padding: 0.9rem 0;
    }
    .area-4 li strong {
      font-size: 0.48rem;
      display: block;
      white-space: nowrap;
      margin-bottom: 0.16rem;
      padding-bottom: 0.16rem;
      border-bottom: 1px solid #fff;
    }
    .area-4-mod2 ul {
      margin-left: 0.64rem;
      padding: 0.2rem 0;
    }

    /* area-5 */
    .area-5 {
      height: 11.76rem;
    }
    .area-5 h2 {
      padding-top: 1.4rem;
      padding-bottom: 0.16rem;
    }
    .area-5 .video-box {
      height: 6.75rem;
      margin-top: 0.32rem;
      overflow: hidden;
    }

    /* area-6 */
    .area-6 {
      padding-top: 0;
      padding-bottom: 2rem;
    }
    .area-6 .desc {
      padding-top: 0.16rem;
      padding-bottom: 0.32rem;
    }
    .area-6 li {
      width: 2.82rem;
    }
    .area-6 li i {
      display: block;
      width: 100%;
      height: 5rem;
    }
    .area-6 li span {
      display: block;
      margin-top: 0.16rem;
    }

    /* area-7 */
    .area-7 {
      padding-bottom: 2rem;
    }
    .area-7 h2 {
      padding-bottom: 0.32rem;
    }
    .area-7-swiper {
      width: 6.9rem;
    }
    .area-7-swiper .img-box {
      width: 6.9rem;
      height: 5.6rem;
      background-color: #fff;
    }
    .area-7-pagination-wrap {
      width: 4.8rem;
      margin-left: 0.4rem;
      margin-top: 0.8rem;
      border-left: 1px solid #979797;
      padding-left: 0.32rem;
    }
    .area-7-pagination-wrap .line {
      display: block;
      position: absolute;
      left: -1px;
      top: 0;
      transition: transform 0.3s linear;
      height: 2.3rem;
      width: 2px;
      background-color: #000;
    }
    .line-d {
      transform: translateY(0);
    }
    .line-y {
      transform: translateY(1.45rem);
    }

    .coming-soon {
      color: rgba(0, 0, 0, 0.45);
      text-align: right;
      margin: -0.35rem 0 0 0;
      padding: 0;
      font-size: 0.14rem;
    }
    :deep(.area-7-pagination li) {
      margin-bottom: 0.55rem;
      color: rgba(0, 0, 0, 0.65);
      &:last-child {
        margin-bottom: 0;
      }
    }
    :deep(.area-7-pagination li .downloadIcon) {
      margin-left: 0.16rem;
      width: 0.24rem;
      height: 0.24rem;
      transition: transform 0.3s linear;
      background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%23222' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' fill='none' fill-rule='evenodd'%3E%3Cpath d='M19.522 16a4.23 4.23 0 0 0 1.582-4.72c-.551-1.753-2.24-2.714-4.066-2.712h-1.054a6.712 6.712 0 0 0-5.72-5.024 6.686 6.686 0 0 0-6.706 3.583 6.78 6.78 0 0 0 .924 7.586M12 19.5v-8M8 16.5l4 4 4-4'/%3E%3C/g%3E%3C/svg%3E");
    }
    :deep(.area-7-pagination li .downloadIcon:hover) {
      transform: scale(1.2);
    }
    // :deep(.area-7-pagination li:last-child) {
    //   margin-bottom: 0;
    // }
    :deep(.area-7-pagination strong) {
      font-size: 0.2rem;
      font-weight: 400;
      margin-bottom: 0.08rem;
    }
    :deep(.area-7-pagination p) {
      margin: 0;
      padding: 0;
    }
    :deep(.area-7-pagination .more-text) {
      margin: 0.24rem 0 0;
      height: 0;
      overflow: hidden;
      transition: all 0.3s linear;
      color: rgba(0, 0, 0, 0.45);
    }
    :deep(.area-7-pagination li:last-child .more-text) {
      margin-bottom: 0;
    }
    :deep(.area-7 .swiper-pagination-bullet) {
      display: block;
      width: auto;
      height: auto;
      border-radius: 0;
      background-color: transparent;
      opacity: 1;
      outline: none;
    }

    :deep(.area-7 .swiper-pagination-bullet-active .more-text) {
      height: 1.35rem;
    }

    :deep(.area-7 .swiper-pagination-bullet-active) {
      color: rgba(0, 0, 0, 0.85);
    }

    :deep(.area-7 .swiper-pagination-bullet-active strong) {
      font-weight: 700;
    }

    :deep(.area-7 .swiper-pagination-bullet-active .more-text) {
      color: rgba(0, 0, 0, 0.65);
    }

    /* area-8 */
    .area-8-in {
      height: 13.3rem;
    }
    .area-8-content {
      padding: 0 2.11rem 0 0.96rem;
    }
    .area-8-img-box {
      margin-top: 3.28rem;
      width: 7.6rem;
      height: 7.6rem;
    }
    .area-8 .specs {
      margin-top: 1.28rem;
    }
    .area-8 .specs h2 {
      margin-bottom: 0.6rem;
    }
    .area-8 table td {
      width: 3.5rem;
      position: relative;
      padding: 0.2rem 0 0.28rem;
    }
    .area-8 table td strong,
    .area-8 table td span {
      display: block;
    }
    .area-8 table td strong {
      font-size: 0.24rem;
      font-weight: 400;
      margin-bottom: 0.1rem;
    }
    .area-8 table td::before {
      content: '';
      display: inline-block;
      position: absolute;
      top: 0;
      left: 0;
      height: 1px;
      width: 0.7rem;
      background-color: #fff;
    }
  }

  /*pc端样式 1440px ~  1650px*/
  @media screen and (max-width: 1650px) and (min-width: 1440px) {
  }

  /*pc端样式 1200px ~  1440px*/
  @media screen and (max-width: 1440px) and (min-width: 1200px) {
  }

  /*pc端样式 768px ~  1200px*/
  @media screen and (max-width: 1200px) and (min-width: 768px) {
  }

  // banner
  :deep(.banner-product-img) {
    width: 4rem;
    height: 4rem;
    right: 2rem;
    // bottom: 0.56rem;
    top: 4rem;
  }
  .area-6 {
    :deep(.desc) {
      width: 12rem;
    }
  }
</style>
